export interface UseLinkToOtherPlatformParams {
  path?: MaybeRefOrGetter<string>
}

/**
 * Ссылка должна использоваться в <a href> или другим способом с запросом на сервер за страницей
 */
export function useLinkToOtherPlatform(
  params: UseLinkToOtherPlatformParams = {},
) {
  const router = useRouter()
  const route = useRoute()

  function addQueryParam(path: string, key: string, value: string) {
    const url = new URL(path, 'https://example.com') // new URL жрет только полные ссылки
    url.searchParams.set(key, value)
    return url.pathname + url.search + url.hash
  }

  function isExistingRoute(path: string): boolean {
    try {
      const resolvedRoute = router.resolve(path)
      return !!resolvedRoute.matched.length
    } catch {
      return false
    }
  }

  const path = computed(() =>
    params.path ? toValue(params.path) : route.fullPath,
  )

  const otherPlatform = computed(() => {
    const { platform } = parsePath(path.value)
    return platform === 'mobile' ? 'desktop' : 'mobile'
  })

  const linkToOtherPlatform = computed(() => {
    const { locale } = parsePath(path.value)

    const altLink = addPrefixes(path.value, {
      locale,
      platform: otherPlatform.value,
    })

    if (isExistingRoute(altLink)) {
      return addQueryParam(altLink, 'platform', otherPlatform.value)
    }

    const homeLink = addPrefixes('/', { locale, platform: otherPlatform.value })
    return addQueryParam(homeLink, 'platform', otherPlatform.value)
  })

  return {
    otherPlatform,
    linkToOtherPlatform,
  }
}
